import CautionIconSVG from '@media/svgs/CautionIconSVG'

const SessionExpiredOverlay = () => {
  return (
    <div className="session-expired-outer-container">
      <div className="session-expired-inner-container">
        <div className="session-expired-header-container">
          <div className="session-expired-header-icon-container">
            <CautionIconSVG color="#f04545" width="20" height="20" />
          </div>
          <div className="session-expired-header-message-container">Authentication Error</div>
        </div>
        <div className="session-expired-divider" />
        <div className="session-expired-content-container">
          <div className="session-expired-content-message-container">
            We were unable to authenticate your session. Please relaunch the game to try again.
          </div>
        </div>
      </div>
    </div>
  )
}

export default SessionExpiredOverlay
